import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-power-bi-report-viewer',
  templateUrl: './power-bi-report-viewer.component.html',
  styleUrls: ['./power-bi-report-viewer.component.scss'],
  standalone: false
})
export class PowerBiReportViewerComponent implements OnInit {
  @Input() reportId = '46f9b1c6-ced3-4e89-b6d3-1362d55819b2';
  @Input() pageId = 'bad38d0f4220689577b7';
  @Input() height = '700px';
  @Input() width = '100%';
  @Input() showToolbar = true;
  @Input() showLink = true;
  @Input() reportName = 'Power BI Report';

  @Output() iframeLoaded = new EventEmitter<void>();

  isLoading = true;
  hasError = false;
  errorMessage = '';
  embedUrl!: SafeResourceUrl;
  reportLink!: string;

  private readonly TENANT_ID = 'd5d2540f-f60a-45ad-86a9-e2e792ee6669';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.initializeReport();
  }

  private initializeReport(): void {
    this.reportLink = this.buildReportLink();
    const embedUrlString = this.buildEmbedUrl();
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrlString);
  }

  private buildReportLink(): string {
    let url = `https://app.powerbi.com/groups/me/reports/${this.reportId}`;
    if (this.pageId) {
      url += `/${this.pageId}`;
    }
    url += `?ctid=${this.TENANT_ID}&experience=power-bi`;
    return url;
  }

  private buildEmbedUrl(): string {
    let url = `https://app.powerbi.com/reportEmbed?reportId=${this.reportId}`;
    url += `&autoAuth=true`;
    url += `&ctid=${this.TENANT_ID}`;
    if (this.pageId) {
      url += `&pageName=${this.pageId}`;
    }
    return url;
  }

  onIframeLoad(): void {
    this.isLoading = false;
    this.iframeLoaded.emit();
  }

  onIframeError(): void {
    this.isLoading = false;
    this.hasError = true;
    this.errorMessage = 'Failed to load Power BI report. Please try again.';
  }

  openInNewTab(): void {
    window.open(this.reportLink, '_blank');
  }

  reload(): void {
    this.isLoading = true;
    this.hasError = false;
    this.initializeReport();
  }

  refresh(): void {
    this.isLoading = true;
    const currentUrl = this.embedUrl;
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    setTimeout(() => {
      this.embedUrl = currentUrl;
    }, 100);
  }
}
